import { MemoryRouter, type NavLinkProps } from 'react-router';

import type { Meta, StoryFn } from '@storybook/react';
import type { MenuLinkProps } from './MenuLink';

import { MenuLink } from './MenuLink';

import './MenuLink.stories.css';

const codeString = `
// Can only be used wrapped in a 'react-router' <MemoryRouter />
 <MenuLink to={linkUrl}>{children}</MenuLink>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/MenuLink',
  component: MenuLink,
  parameters: {
    inspectComponent: MenuLink,
    codeString: codeString,
  },
} as Meta<Omit<NavLinkProps, 'style'>>;

const menuLinks = [
  { to: '/menu-link-1', title: 'Menu Link One' },
  { to: '/menu-link-2', title: 'Menu Link Two' },
  { to: '/menu-link-3', title: 'Menu Link Three' },
];

const Template: StoryFn<Omit<MenuLinkProps, 'style'>> = () => {
  return (
    <MemoryRouter initialEntries={menuLinks.map((link) => link.to)} initialIndex={0}>
      <nav className="navbar">
        {menuLinks.map((link) => (
          <MenuLink key={link.to} to={link.to}>
            {link.title}
          </MenuLink>
        ))}
      </nav>
    </MemoryRouter>
  );
};

export const MenuLinkExample = Template.bind({});

const menuLinks02 = [
  { to: '/menu-link-1', title: 'Menu Link One (no default behavior)', overrideDefaultBehavior: true },
  { to: '/menu-link-2', title: 'Menu Link Two', overrideDefaultBehavior: false },
  { to: '/menu-link-3', title: 'Menu Link Three', overrideDefaultBehavior: false },
];

const TemplateMenuLinkOverrideDefaultBehavior: StoryFn<Omit<MenuLinkProps, 'style'>> = () => {
  return (
    <MemoryRouter initialEntries={menuLinks02.map((link) => link.to)} initialIndex={0}>
      <nav className="navbar">
        {menuLinks02.map((link) => (
          <MenuLink key={link.to} to={link.to} overrideDefault={link.overrideDefaultBehavior}>
            {link.title}
          </MenuLink>
        ))}
      </nav>
    </MemoryRouter>
  );
};

export const MenuLinkOverrideDefaultBehavior = TemplateMenuLinkOverrideDefaultBehavior.bind({});
